import Axios from 'axios'

import { microservice } from 'src/app-config'

const axios = Axios.create({
  baseURL: microservice.domain
})

export {
  axios
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js